const modulesFiles = require.context('./modules', false, /\.js$/).keys();

let api = {};
modulesFiles.forEach((modulePath) => {
  let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  let _api = require(`./modules/${moduleName}`);
  api[moduleName] = _api.default;
});

export default api;
